export default {
  Active: 0,
  Locked: 1,
  Deleted: 2,
}
